import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import MaterialSelector from '../MaterialSelector'
import ImageScrubber from '../ImageScrubber'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView06ImageOptions } from './views/InteriorView06'
import { interiorView07ImageOptions } from './views/InteriorView07'

class Xr41Forwardcabin extends Component {
  constructor (props) {
    super(props)
    this.handleFabricOwnersChange = this.handleFabricOwnersChange.bind(this)
  }

  handleFabricOwnersChange (newValue) {
    let configuration = this.props.configuration
    configuration.FabricOwners = newValue
    configuration.Fabric = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    const image = (
      <ImageScrubber
        images={[
          <ConfiguratorImage
            key='view06'
            boat='Xr41'
            configuration={this.props.configuration}
            options={interiorView06ImageOptions}
          />,
          <ConfiguratorImage
            key='view07'
            boat='Xr41'
            configuration={this.props.configuration}
            options={interiorView07ImageOptions}
          />
        ]}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Sail locker / forward cabin' />
          </h1>

          <p>
            <Trans defaults='Choose upholstery for cushions in saloon.' />
          </p>

          {this.props.configuration.Layout.value === 2 ? (
            <React.Fragment>
              <p>
                <Trans defaults='The sail locker can be upgraded to a full double berth cabin with wardrobes and storage space underneath.' />
              </p>
              
              <p>
                <Trans defaults='Upholstery choice for cushions are shared with the saloon.' />
              </p>

                <p>
                <Trans defaults='Fabric option only available when choosing Sport interior.' />
              </p>
              <MaterialSelector
                options={this.props.FabricOwnersOptions}
                label={this.props.configuration.FabricOwners.label}
                value={this.props.configuration.FabricOwners}
                onChange={this.handleFabricOwnersChange}
              />
            </React.Fragment>
          ) : (
            <p>
              <Trans defaults='Fabric options are not available for this layout.' />
            </p>
          )}
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Forwardcabin)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Forwardcabin.js